import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { Text } from 'mintel-react-ui';

import useTranslation from '../../translations';
import { changeLanguage } from '../../shared/utils';
import Step2Wrapper from './Step2Wrapper';

export type ConfirmEmailProps = {
  email: string;
  registerUrl: string;
  language?: string;
};

export const ConfirmEmail = ({
  email,
  registerUrl,
  language = 'en',
}: ConfirmEmailProps): JSX.Element => {
  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  return (
    <Step2Wrapper>
      <Text.Body2>
        <Trans>
          We’ve sent an email to <b>{email}</b> containing a link. Please click
          the link to complete the registration process and to access your
          Mintel services.
        </Trans>
      </Text.Body2>
      <Text.Body2>
        <Trans i18nKey="editEmailLink">
          If the email address above is incorrect, please{' '}
          <a href={registerUrl}>click here</a> to correct it.
        </Trans>
      </Text.Body2>
    </Step2Wrapper>
  );
};

export type WaitForApprovalProps = {
  language?: string;
};

export const WaitForApproval = ({
  language = 'en',
}: WaitForApprovalProps): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  return (
    <Step2Wrapper>
      <Text.Body2>
        {t(
          'The group you have chosen requires approval, which will normally happen within 24 hours.',
        )}
      </Text.Body2>
      <Text.Body2>
        <Trans>
          If you require faster access, please contact{' '}
          <a href="mailto:helpdesk@mintel.com">Helpdesk</a>.
        </Trans>
      </Text.Body2>
    </Step2Wrapper>
  );
};
